import {makeStyles} from "@material-ui/core";

export default function PagamentosListaCss() {
    return makeStyles(theme => ({
        root: {
            width: '100%',
        },
        heading: {
            fontSize: theme.typography.pxToRem(18),
            fontWeight: theme.typography.fontWeightRegular,
            color: 'black',
        },
        labels: {
            color: 'rgb(118, 118, 118)'
        },
        button: {
        },
        flexContainer: {
            display: 'flex',
            flexFlow: 'row nowrap',
            width: '100%'
        },
        aplicar: {
            marginLeft: 'auto',
        },
        dtBox: {
            width: '120px',
            overflow: 'hidden'
        }
    }));
}